import styled, { css } from 'styled-components';
import { Grid } from '@components/Grid';

const Container = styled(Grid)`
  ${({ withBackground }) => withBackground && css``}
`;

export default Container;
